import React from "react";
import styles from "./EdofDesign.module.css";
import { useNavigate } from "react-router-dom";

export default function EdofLensPromo() {
  const navigate = useNavigate();

  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        <div className={styles.LeftSection}>
          <h2>Patented EDOF Design</h2>
          <h3>A precise equation for every distance</h3>
          <p className={styles.subTitle}>On December 23, 2025, the U.S. Food and Drug Administration cleared Bruno Vision Care’s revolutionary Extended Depth of Focus daily disposable soft contact lens for presbyopic patients.</p>
          <div className={styles.edofLogo}>
            <img src="Images/edof_group.webp" alt="icon abbreviation for Deseyne® extended depth of field contact lens technology" />
            <p className={styles.descriptionText}>This breakthrough Deseyne® contact lens technology introduces a novel optical approach to presbyopic correction. At its core is a small, on-axis hyper-refractive zone that prevents axial and paraxial light from contributing to retinal image formation, redefining how clarity is constructed.</p>
            <p className={styles.descriptionText}>Deseyne® EDOF contact lenses do not rely on accommodation or traditional multifocal optics. Instead, the technology introduces a new optical environment, reshaping how light is processed and reshaping how the visual system constructs continual clarity across any distance. Built with FusionTechnology® inside, for all-day comfort and optical performance.
            </p>
            <p
              onClick={() => navigate("/edof")}
              className={styles.learnMoreText}
            >
              LEARN MORE About EDOF Design
            </p>
          </div>
        </div>
        <div className={styles.RightSection}>
          <div className={styles.rightImageDiv}>
            <img src="Images/section-circle-img2.webp" alt=" woman reading in low light conditions" loading="lazy" decoding="async" />

          </div>
        </div>
      </div>

    </div>
  );
}
